import { Tabs } from "@light-technology/components";
import { Outlet, useLocation } from "react-router";

const tabs = [
  { id: "/settings/personal", href: "/settings/personal", label: "Personal" },
  { id: "/settings/team", href: "/settings/team", label: "Team" },
];

export const SettingsLayout = () => {
  const location = useLocation();
  return (
    <div className="p-4xl">
      <div className="mb-3xl text-display-md font-semibold">Settings</div>
      <Tabs className="mb-7xl" selectedKey={location.pathname}>
        <Tabs.List type="button-gray" size="md" items={tabs}>
          {(tab) => <Tabs.Item {...tab} />}
        </Tabs.List>
      </Tabs>
      <Outlet />
    </div>
  );
};
